module.exports = __webpack_public_path__ + "img/cyprus.8ddc08bf.png";